import * as React        from "react";

import "./colorScheme.scss";

import {cs}              from "@Common/react/chain-services";
import {rColorLineTiles} from "@Common/ui-components/color-picker/color-tiles";

export const ColorScheme = ({colorSchemeData}) => cs(
    (_, next) => {
        if (!colorSchemeData.colorSet?.value || !Object.keys(colorSchemeData?.colorSet?.value).length) return null;
        return next();
    },
    ({}) => (
        <div className="color-scheme-df6">
            <div style={Object.keys(colorSchemeData?.colorSet?.value).length == 1 ? {visibility: "hidden", position: "absolute"} : null}>
                <h3 className="order-details-title" xd-qa-type="label" xd-qa-name="Color Scheme">Color Scheme</h3>
                {rColorLineTiles(colorSchemeData, true)}
            </div>
        </div>
    )
);